import { createContext, Dispatch, SetStateAction } from "react";
import { GroupDocument } from "../Types/dashboardTypes";

type GroupDocumentContextType = {
  groupDocument: GroupDocument;
  setGroupDocument: Dispatch<SetStateAction<GroupDocument>>;
};
const initialState = {
  groupDocument: {
    groupDocument: {
      b2c_oid: "",
      documentType: "",
      groups: { None: [] },
      id: "",
    },
    groupNames: [],
  },
  setGroupDocument: () => null,
};
const GroupDocumentContext = createContext<GroupDocumentContextType>(initialState);

export default GroupDocumentContext;
